<template>
    <svg
        width="1em"
        height="1em"
        fill="currentColor"
        v-bind:class="rotateOn ? 'rotate-90' : 'rotate-0'">
        <use v-bind:href="objectUrlWithFragment" />
    </svg>
</template>

<script>
    import dataUrl from "bootstrap-icons/bootstrap-icons.svg";

    function createObjectURLFromDataUrl(sourceDataUrl) {
        // base64 encoded data urls are in the format 'data:<mime type>;base64,<encoded data>'
        // extract out the encoded part and use atob to decode.
        // Note that atob returns regular javascript string but uses only ascii chars in it.
        // This means that if we want to get the actual bit values, we need to use the charCodeAt function
        const asciiBytes = atob(sourceDataUrl.split(",")[1]);
        const bytes = new Uint8Array(asciiBytes.length);
        for (let i = 0; i < asciiBytes.length; i++) {
            bytes[i] = asciiBytes.charCodeAt(i);
        }

        // once we have the actual bytes we can create a blob. we know the mime type is always svg.
        const blob = new Blob([bytes], { type: "image/svg+xml" });

        // from the blob we can then create
        return URL.createObjectURL(blob);
    }

    /**
     * We could in theory just use the dataUrl directly instead of creating an object Url.
     * However, that means that for each instance of a pc-bs-icon the browser would need to process and decode the
     * data URL. This is usually not a problem because we use dataUrls in css classes, and those only get
     * processeded once, even if you use them thousands of times. In the case of the <use> element however, the
     * data url is directly in the DOM, so the browser is forced to process it each time.
     * This was causing major perf issues for CPRAdmins in trial since we have abour 500 programs there,
     * and for each program we were loading an instance of this component.
     * The workaround here is to preprocess the dataUrl into an svg blob and construct an objectURL just once.
     * Since module level code is only executed once, we then have a constant we can reference it in the href attribute.
     * This saves the browser from having to process and decode the data url each time.
     */
    const objectUrl = createObjectURLFromDataUrl(dataUrl);

    export default {
        props: {
            name: { type: String, required: true },
            rotateOn: { type: Boolean, required: false, default: false }
        },
        computed: {
            objectUrlWithFragment() {
                return `${objectUrl}#${this.name}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .rotate-90 {
        transform: rotate(90deg);
        transition: transform 0.4s;
    }

    .rotate-0 {
        transform: rotate(0deg);
        transition: transform 0.4s;
    }
</style>
